export const legacyTypes = {
  LIST_LEGACY: 'LIST_ERM_JOB',
  LIST_LEGACY_SUCCESS: 'LIST_ERM_ITEM_JOB_SUCCESS',
  LIST_LEGACY_FAIL: 'LIST_ERM_ITEM_JOB_FAIL',
};
